import React, { Component } from 'react';
import ResultBox from './ResultBox';
import AlertMessage from './AlertMessage';
import LuckyButton from './LuckyButton';
import RandomPodcast from './RandomPodcast';
import FeedbackButton from './FeedbackButton';
import './landing.css';

class Landing extends Component {
    constructor(props) {
        super(props);
        this.getSearchParameter = this.getSearchParameter.bind(this);
        this.searchPodcast = this.searchPodcast.bind(this);
        this.setNextPage = this.setNextPage.bind(this);
        this.setPrevPage = this.setPrevPage.bind(this);
        this.searchWithOffset = this.searchWithOffset.bind(this);
        this.searchRandom = this.searchRandom.bind(this);
        this.changeXVisibility = this.changeXVisibility.bind(this);
        this.clearQ = this.clearQ.bind(this);
        this.isEnterKeyPressed = this.isEnterKeyPressed.bind(this);
        this.state = {
            xVisibility: "hidden",
            next_offset: 0,
            resultPodcasts: [],
            randomPodcast: {},
            q: ""
        }
    }

    componentDidMount() {

    }

    setNextPage(e) {
        this.setState({
            next_offset: this.state.next_offset + 10
        }, () => this.searchWithOffset())
    }

    setPrevPage(e) {
        if (this.state.next_offset !== 0) {
            this.setState({
                next_offset: this.state.next_offset - 10
            }, () => this.searchWithOffset())
        }
    }

    searchWithOffset() {
        fetch(process.env.REACT_APP_API_URL + "/search?q=" + this.state.q + "&offset=" + this.state.next_offset, {
            "headers": {
                "X-ListenAPI-Key": process.env.REACT_APP_API_KEY
            }
        }).then(response => response.json())
            .then(body => this.setState({
                resultPodcasts: body.results
            }))
    }

    searchRandom(e) {
        this.setState({
            resultPodcasts: []
        })

        fetch(process.env.REACT_APP_API_URL + "/just_listen", {
            "headers": {
                "X-ListenAPI-Key": process.env.REACT_APP_API_KEY
            }
        }).then(response => response.json())
            .then(body => this.setState({
                randomPodcast: body
            }))
    }

    getSearchParameter(e) {
        this.setState({
            q: e.target.value
        }, this.changeXVisibility)
    }

    clearQ(e) {
        const searchBar = document.querySelector("input");
        searchBar.value = "";
        this.setState({
            q: ""
        }, this.changeXVisibility)
    }

    changeXVisibility() {
        const inputValue = document.querySelector("input").value;
        if (inputValue.length !== 0) {
            this.setState({
                xVisibility: "visible"
            })
        } else {
            this.setState({
                xVisibility: "hidden"
            })
        }
    }

    isEnterKeyPressed(e) {
        if (e.keyCode === 13) {
            this.searchPodcast();
        }
    }

    searchPodcast(e) {
        this.setState({
            randomPodcast: {}
        })
        if (this.state.q !== "") {
            fetch(process.env.REACT_APP_API_URL + "/search?q=" + this.state.q + "&offset=0", {
                "headers": {
                    "X-ListenAPI-Key": process.env.REACT_APP_API_KEY
                }
            }).then(response => response.json())
                .then(body => {
                    this.setState({
                        resultPodcasts: body.results,
                        next_offset: 0
                    })
                })
        }
    }

    render() {
        return (
            <div className="page">
                <div className="logo">
                    <img src="./logo.svg" alt="podcastinator logo" title="Podcastinator - Find and listen the best podcasts on the Internet for free" />
                </div>
                <div className="text">
                    Terminate the search for your favorite podcast here
                    <div className="subText">
                        Search from over 2 million podcast titles and more than 92 million episodes
                    </div>
                </div>
                <div className="search">
                    <i className="bi bi-search" onClick={this.searchPodcast}></i>
                    <input type="text" placeholder="Podcastinate away..." onChange={this.getSearchParameter} onKeyDown={this.isEnterKeyPressed} />
                    <i className="bi bi-x" onClick={this.clearQ} style={{ visibility: this.state.xVisibility }}></i>
                </div>
                <LuckyButton searchRandom={this.searchRandom}></LuckyButton>
                <AlertMessage></AlertMessage>
                {this.state.randomPodcast !== {} && <RandomPodcast randomPodcast={this.state.randomPodcast}></RandomPodcast>}
                <div className="space"></div> {/*remove later*/}
                {this.state.resultPodcasts.length !== 0 &&
                    <div className="nextPage">
                        <i className="bi bi-chevron-left" title="Previous page" onClick={this.setPrevPage}></i>{this.state.next_offset + 1} - {this.state.next_offset + 10}<i className="bi bi-chevron-right" title="Next page" onClick={this.setNextPage}></i>
                    </div>
                }
                <ResultBox
                    podcasts={this.state.resultPodcasts}>
                </ResultBox>
                {this.state.resultPodcasts.length !== 0 &&
                    <div className="nextPage">
                        <i className="bi bi-chevron-left" title="Previous page" onClick={this.setPrevPage}></i>{this.state.next_offset + 1} - {this.state.next_offset + 10}<i className="bi bi-chevron-right" title="Next page" onClick={this.setNextPage}></i>
                    </div>
                }
                <FeedbackButton></FeedbackButton>
            </div>
        );
    }
}

export default Landing;